import React from "react";
import headerImg from "../utils/images/headerImg.jpg";

const UpperContent = () => {
    return (
        <div className="header-content bg-gray-300 py-8 px-4">
            <div className="flex flex-col sm:flex-row items-center sm:space-x-8">
                {/* Left Section: Image */}
                <div className="w-full sm:w-1/2 flex justify-center sm:justify-start">
                    <img
                        src={headerImg}
                        alt="Digital Society"
                        className="w-4/5 sm:w-full h-auto max-h-[700px] object-contain"
                    />
                </div>

                {/* Right Section: Mission Statement */}
                <div className="py-12 px-6">
                    <div className="max-w-2xl mx-auto text-center">
                        {/* Heading */}
                        <h1 className="text-4xl sm:text-5xl font-extrabold mb-6 text-blue-950" style={{ lineHeight: '1.2' }}>
                            “आपके परिवार का, <br />
                            आपके रिश्तेदारी का, <br />
                            आपके समाज का <br />
                            ऐप ...”
                        </h1>
                        {/* Paragraph */}
                        <p className="text-lg sm:text-xl leading-relaxed text-blue-900">
                            ⁠समाज को सुव्यवस्थित तरीक़े से एक करने वाला प्लैटफ़ॉर्म
                            {/* हमारा मिशन समाज व समाज बंधुयो संगठित कर सामाजिक रूप से प्रत्येक गतिविधि व
                            सामाजिक कार्यो में शामिल करना, वंशावली द्वारा रिश्तो की पहचान और संचार में सुधार
                            करना और उन्हें इस सुव्यवस्थित तरीके से प्रबंधित करने व डिजिटल मंच प्रदान कर समाज
                            का उत्थान करने / समाज को विकास की बुलंदियों तक पहुंचने में मदद करना है। */}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpperContent;
